import { SmilePlus } from 'lucide-react';
import { Popover, PopoverTrigger, PopoverContent } from '@/components/ui/popover';
import { REACOES_RAPIDAS } from '@/lib/reacoes';

interface ReactionRowProps {
  onReact: (emoji: string) => void;
}

// Linha pura dos 6 emojis — exportada para teste determinístico.
export function ReactionRow({ onReact }: ReactionRowProps) {
  return (
    <div className="reaction-bar">
      {REACOES_RAPIDAS.map((e) => (
        <button
          key={e}
          type="button"
          className="reaction-bar__btn"
          aria-label={e}
          onClick={() => onReact(e)}
        >
          {e}
        </button>
      ))}
    </div>
  );
}

interface ReactionBarProps {
  onReact: (emoji: string) => void;
}

export function ReactionBar({ onReact }: ReactionBarProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" className="msg__react-btn" aria-label="reagir">
          <SmilePlus size={13} />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="center"
        className="w-auto p-1"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <ReactionRow onReact={onReact} />
      </PopoverContent>
    </Popover>
  );
}
